import * as React from "react";
const SvgFiRrLightbulbOn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lightbulb-on_svg__a)">
      <path
        fill="#062147"
        d="M11.864 4.001c-4.184.069-7.709 3.526-7.858 7.705a7.96 7.96 0 0 0 2.75 6.326C7.547 18.719 8 19.775 8 21c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3v-.375c0-.966.455-1.898 1.282-2.626A7.99 7.99 0 0 0 20 12a7.94 7.94 0 0 0-2.39-5.703c-1.541-1.516-3.583-2.345-5.746-2.296M14 21a1 1 0 0 1-1 1h-2c-.552 0-1-.448-1-1.069A6 6 0 0 0 9.923 20h4.118a5 5 0 0 0-.041.625zm1.962-4.503A6 6 0 0 0 14.722 18H13v-4.184A3 3 0 0 0 15 11a1 1 0 1 0-2 0 1 1 0 1 1-2 0 1 1 0 1 0-2 0c0 1.302.839 2.402 2 2.816V18H9.254a5.5 5.5 0 0 0-1.188-1.478 5.97 5.97 0 0 1-2.062-4.744c.112-3.134 2.756-5.726 5.894-5.777H12c1.586 0 3.077.609 4.208 1.723a5.99 5.99 0 0 1-.245 8.774zm.823-14.023L18.02.464a.996.996 0 0 1 1.375-.328 1 1 0 0 1 .328 1.375l-1.235 2.01a.997.997 0 0 1-1.375.329 1 1 0 0 1-.328-1.376m6.628 4.148-1.933.872a1 1 0 1 1-.822-1.822l1.933-.872a.997.997 0 0 1 1.322.5 1 1 0 0 1-.5 1.322M4.194 1.51A1 1 0 1 1 5.899.465l1.232 2.011A1 1 0 1 1 5.426 3.52zm-.483 5.551a1 1 0 0 1-1.333.469L.58 6.669a1 1 0 0 1-.47-1.333.996.996 0 0 1 1.333-.47l1.798.861a1 1 0 0 1 .47 1.334"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lightbulb-on_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLightbulbOn;
